
import { defineComponent, ref, watch } from "vue";
import {useRouter} from "vue-router";

import Header from "@/components/Header/Header.vue";
import CommonButton from "@/components/Buttons/CommonButton.vue";

export default defineComponent({
  name: "ContactView",
  components: { Header, CommonButton },

  setup() {
		const router = useRouter();

    const formData = ref({
      email: "",
      message: "",
    });

    const emailError = ref("Please, type an email");
    const messageError = ref("Please, type a message");
    const isEmailInvalid = ref(false);
    const isMessageInvalid = ref(false);

    /** Checks if email is valid and returns appropriate error message */
    const checkEmail = (email: string) => {
      const regex = new RegExp(
        '^(([^<>()[\\]\\\\.,;:\\s@"]+(\\.[^<>()[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3})|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'
      );

      if (!email.toLowerCase().match(regex) || email === "") {
        isEmailInvalid.value = true;
        return "Please, type a valid email";
      } else {
        isEmailInvalid.value = false;
        return "Please, type an email";
      }
    };

    /** Checks if message is valid and returns appropriate error message */
    const checkMessage = (message: string) => {
      if (message === "") {
        isMessageInvalid.value = true;
        return "Message cannot be empty";
      } else {
        isMessageInvalid.value = false;
        return "";
      }
    };

    watch(formData.value, async (newValue) => {
      if (newValue) {
        emailError.value = checkEmail(newValue.email);
        messageError.value = checkMessage(newValue.message);
      }
    });

    const encode = (data: any) => {
      return Object.keys(data)
        .map(
          (key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
        )
        .join("&");
    };

    const handleSubmit = () => {
      fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode({ "form-name": "contact", ...formData.value }),
      })
        .then(() => {
	        console.log("Form successfully submitted");
	        router.push('/thanks')
        })
        .catch((error) => {
	        alert(error);
	        router.push('/404')
        });
    };

    return {
      emailError,
      formData,
      handleSubmit,
      isEmailInvalid,
      isMessageInvalid,
      messageError,
    };
  },
});
